import { useState, useEffect } from 'react';
import { useLocation, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Sidenav from '../../Sidenav/Sidenav';
import monitoramentoIcon from '../../../assets/svgs/monitoramento.svg';

import {
  SearchNormal1,
  FolderOpen,
  Briefcase,
  LogoutCurve,
  Message,
  Subtitle,
  Book1,
  Buildings,
} from 'iconsax-react';
import { useKnowledgeStore } from '../../../store/ducks/knowledge';

import '../../../modules/jurisprudential-search/components/search/CardsHome/tooltip.scss';

import { PostHogSendMenu } from '../../../utils/PostHogSendEvents';

const PATHS = {
  principal: '0',
  home: '1',
  home_tributario: '10',
  home_trabalhista: '11',
  colecoes: '2',
  dashboards: '3',
  monitoramento: '4',
  notificacao: '5',
  admin: '6',
  perfil: '7',
  logout: '8',
  docs: '9',
  jurimetrics_trabalhista: '12',
};

const TuriviusSidenav = ({ history, actionPermissions = {} }) => {
  const { pathname } = useLocation();
  const { open: openKnowledge } = useKnowledgeStore();

  const [activeKey, setActiveKey] = useState(null);
  const [showNavbar, setShowNavbar] = useState(false);
  const profile = JSON.parse(localStorage.getItem('profile'));
  const permissions = JSON.parse(localStorage.getItem('permissions'));

  useEffect(() => {
    if (!profile) setShowNavbar(false);
    const handleResize = () => {
      setShowNavbar(
        profile && !['/trial', '/login', '/sso'].includes(pathname),
      );
    };

    window.addEventListener('resize', handleResize);

    return () => {
      setShowNavbar(
        profile && !['/trial', '/login', '/sso'].includes(pathname),
      );
      window.removeEventListener('resize', handleResize);
    };
  }, [history, profile]);

  const header = {
    img: '/new-logo-white.svg',
    onClick: () => history.push('/pesquisa'),
  };

  const IconColor = '#344054';
  const hoverIconColor = '#344054';

  const navItems = [
    {
      icon: 'ri-search-line',
      children: '',
      empty: {
        name: 'Clique aqui para solicitar!',
        onClick: () => history.push('/solicitar-tributario'),
        show: false,
      },
      products: [
        {
          id: 'menu-jurisprudence',
          icon: <SearchNormal1 size="24" color={IconColor} />,
          icon_hover: <SearchNormal1 size="24" color={hoverIconColor} />,
          icon_hover_mouse: <SearchNormal1 size="24" color="#101828" />,
          name: 'Jurisprudência',
          route: '/pesquisa',
          onClick: () => {
            history.push('/pesquisa');
            PostHogSendMenu('jurisprudencia'); // POSTHOG_NEW
          },
          show: true,
        },
        {
          id: 'menu-collections',
          name: 'Coleções',
          icon: <FolderOpen size="24" color={IconColor} />,
          icon_hover: <FolderOpen size="24" color={hoverIconColor} />,
          icon_hover_mouse: <FolderOpen size="24" color="#101828" />,
          route: '/colecoes',
          onClick: () => {
            history.push('/colecoes');
            PostHogSendMenu('colecoes'); // POSTHOG_NEW
          },
          show: true,
        },
        {
          id: 'menu-monitoring',
          name: 'Monitoramento',
          icon: (
            <img src={monitoramentoIcon} size="24" alt="icone Monitoramento" />
          ),
          icon_hover: (
            <img src={monitoramentoIcon} size="24" alt="icone Monitoramento" />
          ),
          icon_hover_mouse: (
            <img
              src={monitoramentoIcon}
              size="24"
              alt="icone Monitoramento"
              style={{
                filter:
                  'brightness(0) saturate(100%) invert(25%) sepia(50%) saturate(300%) hue-rotate(180deg) brightness(98%) contrast(105%)',
              }}
            />
          ),
          route: '/monitoramento',
          onClick: () => {
            history.push('/monitoramento');
            PostHogSendMenu('monitoramento'); // POSTHOG_NEW
          },
          show: true,
        },
        {
          id: 'menu-jurimetrics-trab',
          name: 'Jurimetria Trabalhista',
          icon: <Briefcase size="24" color={IconColor} />,
          icon_hover: <Briefcase size="24" color={hoverIconColor} />,
          icon_hover_mouse: <Briefcase size="24" color="#101828" />,
          route: '/jurimetria-trabalhista',
          onClick: () => {
            history.push('/jurimetria-trabalhista');
            PostHogSendMenu('jurimetria_trabalhista'); // POSTHOG_NEW
          },
          show: actionPermissions?.search_labor_jurimetry?.has_permission != 0,
        },
        // {
        //   id: 'menu-business-dash',
        //   name: 'Área Empresarial',
        //   icon: <Buildings size="16" color={IconColor} />,
        //   icon_hover: <Buildings size="16" color={hoverIconColor} />,
        //   route: '/dashboard-empresarial',
        //   onClick: () => history.push('/dashboard-empresarial'),
        //   show: permissions?.trabalhista?.business_dashboard?.area_empresarial,
        // },
      ],
    },
  ];

  const footer = [
    {
      icon: <Subtitle size="18" color={IconColor} />,
      icon_hover_mouse: <Subtitle size="18" color="#101828" />,
      children: 'Artigos',
      onClick: () => {
        window.open(
          'https://www.turivius.com/portal/',
          '_blank',
          'noopener,noreferrer',
        );
        // PostHogSendMenu('artigos'); // POSTHOG_NEW
      },
      show: true,
    },
    {
      icon: <Book1 size="20" color={IconColor} />,
      icon_hover_mouse: <Book1 size="20" color="#101828" />,
      children: 'Dúvidas Frequentes',
      onClick: () => {
        openKnowledge();
        // PostHogSendMenu('faq'); // POSTHOG_NEW
      },
      show: true,
    },
    // {
    //   icon: <Message size="16" />,
    //   children: 'Suporte',
    //   onClick: () =>
    //     {window.open(`${window.location.href}#hs-chat-open`, '_self');
    //     PostHogSendMenu('suporte'); // POSTHOG_NEW
    // },
    //   show: true,
    // },
    {
      icon: <LogoutCurve size="20" color={IconColor} />,
      icon_hover_mouse: <LogoutCurve size="20" color="#101828" />,
      children: 'Sair',
      onClick: () => history.push('/logout'),
      show: true,
    },
  ];

  useEffect(() => {
    if (history.location.pathname) {
      if (
        history.location.pathname.includes('tributario') ||
        history.location.pathname.includes('trabalhista') ||
        history.location.pathname.includes('resultados')
      ) {
        setActiveKey(PATHS['home']);
      } else if (history.location.pathname.replace('/', '') === '') {
        setActiveKey(PATHS['principal']);
      } else if (history.location.pathname.includes('colecoes')) {
        setActiveKey(PATHS['colecoes']);
      } else if (history.location.pathname.includes('monitoramento')) {
        setActiveKey(PATHS['monitoramento']);
      } else if (history.location.pathname.includes('admin')) {
        setActiveKey(PATHS['admin']);
      } else if (history.location.pathname.includes('docs')) {
        setActiveKey(PATHS['docs']);
      } else {
        setActiveKey(PATHS[history.location.pathname.replace('/', '')]);
      }
    }
  }, [history]);

  return showNavbar ? (
    <Sidenav
      footer={footer}
      navItems={navItems.map((item) => ({
        ...item,
        products: item.products.map((product) => ({
          ...product,
          icon: (
            <div>
              <span>{product.icon}</span>
            </div>
          ),
        })),
      }))}
      defaultActiveKey={activeKey}
      header={header}
      permissions={permissions}
    />
  ) : null;
};

const mapStateToProps = (state) => ({
  profile: state.profiles.profile,
  permissions: state.profiles.permissions,
});

export default connect(mapStateToProps, {})(withRouter(TuriviusSidenav));
